import { get_audio_poster } from "./audio"
import { get_video_poster } from "./video"
import { cont_match_img } from "./image"
import { domClientWidth, env as ENV } from "../env"
import "../graft"
import { urlFormatToJump } from "../mdRouter"

const defineWidth = domClientWidth()

export const cont_match_reg = function (node, env, maxWidth, channel) {
    if (!node) return ""
    let str = node.replace(/html-from-editor|p-padding/g, '')
    var lower_str = str.toLowerCase()
    var joint_arr = []
    var match_arr = [
        { pre: "<a ", end: "</a>", extend: [" href=", " class=", " target="] },
        { pre: "<img", end: ">", extend: [
            " id=", 
            " class=", 
            " src=", 
            " width=", 
            " height=", 
            " data-rate=",
            " data-url=",
            " data-name=",
            " data-duration=",
            " data-original=",
            " data-cke-saved-src=",
            " _url=", 
            " _name=", 
            " _duration=",
            " style=",
            " data-w=",
            " data-video=",
            " data-cover="] },
        // { pre: "<video", end: "</video>", extend: [" poster=", " src=", " width=", " height="] },
        { pre: "<video", end: "/>", extend: [" poster=", " src=", " width=", " height=", " _url="] },
        { pre: "<embed", end: ">" },
        { pre: "<audio", end: ">", 
            extend: [" _url=", " _name=", " _duration=", " data-duration=", " data-name=", " src="] },
        { pre: "<input", end: ">" },
        { pre: "<p", end: ">", extend: [" style="]},
        { pre: "<article", end: ">", extend: [] }
    ]

    // eslint-disable-next-line
    while (true) {
        var check_arr = {} 
        match_arr.forEach(function(val) {
            var check_idx = lower_str.indexOf(val.pre)
            if (check_idx != -1) {
                check_arr[check_idx] = val
            }
        })
        var check_arr_idx = Object.keys(check_arr)[0] // check_arr的key值
        if (check_arr_idx) {
            joint_arr.push(cont_match_href(str.substring(0, check_arr_idx)))
            str = str.slice(check_arr_idx)
            lower_str = lower_str.slice(check_arr_idx)
        } else if (check_arr_idx == undefined) {
            joint_arr.push(cont_match_href(str, "check"))
            break
        }
        var text_complete_idx =
            lower_str.indexOf(check_arr[check_arr_idx].end) + check_arr[check_arr_idx].end.length

        if (check_arr[check_arr_idx].pre == '<video') {
            let strend1 = lower_str.indexOf('</video>')
            let strend2 = lower_str.indexOf('/>')
            if (strend1 > -1 && strend2 > -1) {
                text_complete_idx = strend1 < strend2 ? strend1 + 8 : strend2 + 2
            } else if (strend1 > -1) {
                text_complete_idx = strend1 + 8
            } else if (strend2 > -1) {
                text_complete_idx = strend2 + 2
            }
        }

        var text_complete = str.substring(0, text_complete_idx)
        var after_check_idx = 0
        match_arr.forEach(function(val) {
            if (val.pre != "<a " && val.end != "</a>") {
                var pre_check_idx = text_complete.indexOf(val.pre)
                if (pre_check_idx > 0) {
                    if (after_check_idx == 0 || pre_check_idx < after_check_idx) {
                        after_check_idx = pre_check_idx
                    }
                }
            }
        })
        if (after_check_idx != 0) {
            text_complete_idx = after_check_idx
            text_complete = str.substring(0, text_complete_idx)
        }
        str = str.slice(text_complete_idx)
        lower_str = lower_str.slice(text_complete_idx)
        if (after_check_idx != 0) {
            joint_arr.push(text_complete)
        } else if (
            check_arr[check_arr_idx].pre == "<a " ||
            check_arr[check_arr_idx].pre == "<img" ||
            check_arr[check_arr_idx].pre == "<video"||
            check_arr[check_arr_idx].pre == "<article"
        ) {
            var attr_arr = {}
            check_arr[check_arr_idx].extend.forEach(function(val) {
                var attr_idx = text_complete.indexOf(val)
                if (attr_idx != -1) {
                    attr_idx += val.length + 1
                    var attr_val = text_complete.slice(attr_idx)
                    attr_arr[val] = attr_val.substring(0, attr_val.indexOf('"'))
                }
            })
            if (check_arr[check_arr_idx].pre == "<a " && check_arr[check_arr_idx].end == "</a>") {
                attr_arr["title"] = cont_match_href(text_complete.replace(/<[^<>]+?>/g, ''), "verif");
                joint_arr.push(cont_match_card(attr_arr, check_arr[check_arr_idx].extend))
            } else if (check_arr[check_arr_idx].pre == "<img") {
                joint_arr.push(cont_match_img(attr_arr, check_arr[check_arr_idx].extend, maxWidth))
            } else if (check_arr[check_arr_idx].pre == "<video") {
                joint_arr.push(cont_match_video(attr_arr, check_arr[check_arr_idx].extend))
            } else if (check_arr[check_arr_idx].pre == "<article") {
                joint_arr.push('<article>')
            }
        } else {
            joint_arr.push(text_complete)
        }
    }

    const editorBox = document.createElement("div")
    editorBox.className = "html-from-editor"
    var content = joint_arr.join("")
    // editorBox.innerHTML = content.replace(/↵/g, "")
    editorBox.innerHTML = content

    let audios = editorBox.querySelectorAll(".html-from-editor .edui-faked-audio")
    if (audios.length) {
        audios.forEach((ele, index) => {
            get_audio_poster(ele, env, channel, index)
        })
    }

    let videos = editorBox.querySelectorAll(".html-from-editor .edui-faked-video")
    if (videos.length) {
        videos.forEach((ele) => {
            get_video_poster(ele, env)
        })
    }

    let links = editorBox.querySelectorAll(".html-from-editor a")
    if (links.length) {
        links.forEach((ele) => {
            if (ele.children && ele.children.length == 0) {
                ele.setAttribute("class", "edui-faked-link")
                const link = ele.getAttribute("href")
                if (link && link.length) {
                    ele.addEventListener("click", function(event){
                        event.preventDefault();
                        urlFormatToJump(link)
                    });
                }
            }
        })
    }

    // 图片处理：
    // app内可查看大图；
    // 图片加载失败，点击再次加载
    let images = editorBox.querySelectorAll(".html-from-editor img")
    if (images.length) {
        let imageUrls = []
        images.forEach((ele) => {
            ele.onload = function() {
                ele.setAttribute('loaded', true)
            }
            if ((!ele.getAttribute('class') || ele.getAttribute('class').indexOf("emoji") == -1)) {
                if (ele.parentNode.nodeName != "A") {
                    const len = imageUrls.length
                    ele.addEventListener("click", function () {
                        // 只有在客户端才可以查看大图
                        if (ele.getAttribute('loaded') && (ENV.isModianIos() || ENV.isModianAndroid())) {
                            window.graft.app({
                                functionName: "onImageClicked",
                                functionParams: {
                                    imageUrls: imageUrls,
                                    imageIndex: len
                                }
                            })
                        } else {
                            ele.src = ele.src
                        }
                    })
                }
                imageUrls.push(ele.getAttribute('src'))
            }
        })
    }

    let tagP = editorBox.childNodes
    if (tagP.length) {
        for (let i = 0; i < tagP.length; i++) {
            findNodeType(tagP[i])
        }
    }
    return editorBox
}

export const cont_match_card = function (arr, extend, type, from) {
    var than_url_str = "<a"
    var than_url_text = from == 'text' ? arr[" href="] || arr : "网页链接"
    var than_url_href = arr[" href="] || arr
    var match_zhongchou_detail = /(?=.*zhongchou\.modian)(?=.*\/item\/)^.*$/
    var match_m_detail = /(?=.*m\.modian)(?=.*\/project\/)^.*$/
    var match_subscribe_detail = /(?=.*t\.modian)^.*$/
    if (match_zhongchou_detail.test(than_url_href) || match_m_detail.test(than_url_href)) {
        than_url_text = "众筹详情"
        // 去掉众筹链接上的锚点
        if (match_zhongchou_detail.test(than_url_href)) {
            if (arr[" href="]) {
                arr[" href="] = arr[" href="].replace(/#([^?]*)/, '');
            } else if (arr) {
                arr = arr.replace(/#([^?]*)/, '');
            }
        }
    } else if (match_subscribe_detail.test(than_url_href)) {
        than_url_text = "云养计划"
    }
    if (type == "verif") {
        return than_url_text
    }
    if (typeof arr == "object") {
        var than_class = arr[" class="] || ""
        arr[" class="] = than_class + " lower_a_card"
        if (arr["title"]) {
            than_url_text = arr["title"]
        }
        extend.forEach(function(val) {
            if (arr[val]) {
                than_url_str += val + '"' + arr[val] + '"'
            }
        })
    } else {
        than_url_str += ' href="' + arr + '" class="lower_a_card"'
    }
    than_url_str += ">" + than_url_text + "</a>"
    return than_url_str
}
export const cont_match_href = function(arr, type) {
    var short_cont_match_reg = /(https?|http|ftp|file):\/\/[-a-z0-9+&@#/%?=~_|!:,.;]+[-a-z0-9+&@#/%=~_|]/gi
    var arrMatch = { http: " http", ftp: " ftp", file: " file" }
    var arrEntities = { lt: "<", gt: ">", amp: "&", quot: '"' }
    arr = arr.replace(/&(lt|gt|amp|quot);/gi, function(all, t) {
        return arrEntities[t]
    })
    arr = arr.replace(/(http|ftp|file)/gi, function(all, t) {
        return arrMatch[t]
    })
    // arr = arr.replace(/(\s|&nbsp;)+/g, " ")
    var arr_suffix = 0
    if (type == "check") {
        if (arr.substring(arr.length - 6) == "......") {
            arr_suffix = 6
        } else if (arr.substring(arr.length - 3) == "...") {
            arr_suffix = 3
        }
    }
    return arr.replace(short_cont_match_reg, function(word, team, index) {
        if (arr_suffix && index + word.length == arr.length - arr_suffix) {
            return word
        } else {
            // var match_modian = /(?=.*\.modian.com)^.*$/
            var match_modian = /(?=.*(\.modian\.com|\.modianinc\.com))^.*$/
            if (match_modian.test(word)) {
                return cont_match_card(word, {}, type, 'text')
            } else {
                return word
            }
        }
    })
}
function setBigDom(dom) {
    function hasBigDom(dom) {
        if (dom.nodeType === 1) {
            if (dom.nodeName === 'IMG') {
                if (parseInt(dom.getAttribute("data-rate")) >= 1 || (dom.getAttribute("data-w") && parseInt(dom.getAttribute("data-w")) >= defineWidth)) {
                    dom.className += " big-dom"
                }
            } else if (dom.className === 'video_field') {
                dom.className += " big-dom"
            } else {
                if (dom.children.length) {
                    for (let i = 0; i < dom.children.length; i++) {
                        hasBigDom(dom.children[i])
                    }
                }
            }
        }
    }
    hasBigDom(dom)
}

function findTextDom(dom) {
    let isTextDom = false
    function hasTextDom(dom) {
        if (dom.nodeType === 3 && dom.data.replace(/\s+/, '')) {
            isTextDom = true
        } else if (dom.nodeType === 1) {
            if (!['video_field', 'audio_field'].includes(dom.className)) {
                if (dom.childNodes.length) {
                    for (let i = 0; i < dom.childNodes.length; i++) {
                        hasTextDom(dom.childNodes[i])
                    }
                }
            }
        }
    }
    hasTextDom(dom)
    return isTextDom
}

function findNodeType(dom) {
    let hasText = findTextDom(dom)
    if (hasText) {
        // let oldClass = dom.getAttribute('class') ? dom.getAttribute('class').split(' ').filter(i => i) : []
        // oldClass.push('p-padding')
        // dom.setAttribute("class", oldClass.join(' '))
        // setBigDom(dom)
        if(dom.nodeName == 'TABLE'){
            // table标签不做处理
        }else if (dom.nodeName == '#text') {
            var tag = document.createElement('p');
            tag.setAttribute("class", 'p-padding')
            dom.parentNode.replaceChild(tag, dom)
            tag.appendChild(dom)
            setBigDom(dom)
        } else {
            let oldClass = dom.getAttribute('class') ? dom.getAttribute('class').split(' ').filter(i => i) : []
            oldClass.push('p-padding')
            dom.setAttribute("class", oldClass.join(' '))
            setBigDom(dom)
        }
    }
}

function cont_match_video(arr) {
    return `<div><video poster="${arr[" poster="]
        }" duration="" class="edui-faked-video" pluginspage="http://www.macromedia.com/go/getflashplayer" data-src="${arr[" src="]
        }" width="${arr[" width="]}" height="${arr[" height="]
        }" wmode="transparent" play="true" loop="false" menu="false" allowscriptaccess="never" allowfullscreen="true"></video></div><p>`
}

export default cont_match_reg